
import { createSelector } from 'reselect'

const getCoins  = (state: Store) => state.coins
const arrIsEmpty = (arr) => arr.length === 0

const getCoinsExtended = (coins) => {

  if(arrIsEmpty(coins)) return []

  const sortedCoins = coins.sort((a, b) => {
    if (!a.mcap) a.mcap = 0;
    if (!b.mcap) b.mcap = 0;
    if (a.mcap < b.mcap) return 1;
    if (a.mcap > b.mcap) return -1;
    return 0;
  })

  console.log(sortedCoins)
  return sortedCoins
}

export default createSelector([getCoins], getCoinsExtended)



// WEBPACK FOOTER //
// ./src/selectors/coinsExtended.js